// extracted by mini-css-extract-plugin
export default {"sortPanel":"SortPanel_sortPanel__1Teaz","label":"SortPanel_label__q364N"};